import React, { Component } from 'react'
//вimport 'bootstrap/dist/css/bootstrap.css';
import './styles.scss'
import exitLeftActive from './assets/exit_left_active.svg'
import exitLeftNoActive from './assets/exit_left_no_active.svg'
import exitRigthActive from './assets/exit_rigth_active.svg'
import exitRigthNoActive from './assets/exit_rigth_no_active.svg'
import arrowLeftActive from './assets/arrow_left_active.svg'
import arrowLeftNoActive from './assets/arrow_left_no_active.svg'
import arrowRigthActive from './assets/arrow_rigth_active.svg'
import arrowRigthNoActive from './assets/arrow_rigth_no_active.svg'
// import lestnichaLeftActive from './assets/lestnicha_left_active.svg'
// import lestnichaLeftNoActive from './assets/lestnicha_left_no_active.svg'
// import lestnichaRigthActive from './assets/lestnicha_rigth_active.svg'
// import lestnichaRigthNoActive from './assets/lestnicha_rigth_no_active.svg'
import zoom from './assets/zoom.svg'
import busket from './assets/busket.png'
import cart from './assets/cart.svg'

import ZoomPopUp from "./zoom_popup"
import FloorsNumbersPopUp from "./floors_numbers_popup"
import PostsNumbersPopUp from "./posts_numbers_popup"
import FlatsNumbersPopUp from "./flats_numbers_popup"
import FlatsNumbWitArrPopUp from "./flats_numb_with_arrors_popup"
import FlatsNumbByfloorsPopUp from "./flats_numbers_by_floors_popup"

interface IItemProps {
    item: {
        id: string,
        img: string,
        name: string,
        price: number,
        size: string,
        type: number
    }
    addProduct: (plate: any, count: number) => void
}

class Item extends Component<IItemProps> {

    public state = {
        isEditing: false,
        count: 0,
        leftIcon: false,
        rigthIcon: true,
        isOpenzoomPopUp: false,
        isFloorsNumberPopUpOpen: false,
        isPostsNumberPopUpOpen: false,
        isFlatsNumberPopUpOpen: false,
        isFlatsNumbWitArrPopUpOpen: false,
        isFlatsNumbByfloorsPopUp: false
    }

    // public onEditClickHandler = () =>{
    //     this.setState({isEditing: true})
    // }
    public onMinusClickHandler = () => {
        if (this.state.count > 0) {
            this.setState({ count: this.state.count - 1 })
        }
    }
    public onPlusClickHandler = () => {
        this.setState({ count: this.state.count + 1 })
    }

    // public onChangeActiveLeft = () => {
    //     if (this.state.rigthIcon) {
    //         this.setState({ leftIcon: !this.state.leftIcon, rigthIcon: this.state.leftIcon })
    //     }
    // }
    // public onChangeActiveRigth = () => {
    //     if (this.state.leftIcon) {
    //         this.setState({ rigthIcon: !this.state.rigthIcon, leftIcon: this.state.rigthIcon })
    //     }

    // }

    public onAddProduct = () => {
        this.props.addProduct(this.props.item, this.state.count)
        this.setState({count: 0})
    }

    public onOpenPopup = (type: number) => {
        switch (type) {
            case 39:
                this.setState({ isFloorsNumberPopUpOpen: !this.state.isFloorsNumberPopUpOpen })
                break
            case 51:
                this.setState({ isPostsNumberPopUpOpen: !this.state.isPostsNumberPopUpOpen })
                break
            case 43:
                this.setState({ isFlatsNumberPopUpOpen: !this.state.isFlatsNumberPopUpOpen })
                break
            case 79:
                this.setState({ isFlatsNumberPopUpOpen: !this.state.isFlatsNumberPopUpOpen })
                break
            case 46:
                this.setState({ isFlatsNumberPopUpOpen: !this.state.isFlatsNumberPopUpOpen })
                break
            case 47:
                this.setState({ isFlatsNumberPopUpOpen: !this.state.isFlatsNumberPopUpOpen })
                break
            case 45:
                this.setState({ isFlatsNumbWitArrPopUpOpen: !this.state.isFlatsNumbWitArrPopUpOpen })
                break
            case 81:
                this.setState({ isPostsNumberPopUpOpen: !this.state.isPostsNumberPopUpOpen })
                break
            case 48:
                this.setState({ isPostsNumberPopUpOpen: !this.state.isPostsNumberPopUpOpen })
                break
            case 44:
                this.setState({ isFlatsNumbByfloorsPopUp: !this.state.isFlatsNumbByfloorsPopUp })
                break
            case 53:
                this.setState({ isFlatsNumbByfloorsPopUp: !this.state.isFlatsNumbByfloorsPopUp })
                break
            case 82:
                this.setState({ isFlatsNumbByfloorsPopUp: !this.state.isFlatsNumbByfloorsPopUp })
                break
        }
    }

    public onOpenZoomPopup = () => {
        this.setState({ isOpenzoomPopUp: !this.state.isOpenzoomPopUp })
    }



    public render() {
        const { img, name, price, size, type, id } = this.props.item
        const { leftIcon, rigthIcon, count } = this.state

        return (
            <div className="item-container">
                <div className="item">
                    {/* {type === 61 && <div className="exits">
                        <img onClick={this.onChangeActiveLeft} src={leftIcon ? exitLeftActive : exitLeftNoActive} />
                        <img onClick={this.onChangeActiveRigth} src={rigthIcon ? exitRigthActive : exitRigthNoActive} />
                    </div>} */}
                    {/* {type === 56 && <div className="exits">
                        <img onClick={this.onChangeActiveLeft} src={leftIcon ? lestnichaLeftActive : lestnichaLeftNoActive} />
                        <img onClick={this.onChangeActiveRigth} src={rigthIcon ? lestnichaRigthActive : lestnichaRigthNoActive} />
                    </div>} */}
                    {/* {type === 40 && <div className="exits">
                        <img onClick={this.onChangeActiveLeft} src={leftIcon ? arrowLeftActive : arrowLeftNoActive} />
                        <img onClick={this.onChangeActiveRigth} src={rigthIcon ? arrowRigthActive : arrowRigthNoActive} />
                    </div>} */}
                    {(type === 41 || type === 83) && <div className="zoom">
                        <img src={zoom} onClick={this.onOpenZoomPopup} />
                    </div>}
                    <div className='image-container'>
                        <img src={img} />
                        {this.state.isOpenzoomPopUp && <ZoomPopUp onClose={this.onOpenZoomPopup} url={img} id={id} />}
                    </div>
                    {type === 39 || type === 43 || type === 46 || type === 45 || type === 47 || type === 48 ||
                        type === 51 || type === 79 || type === 81 || type === 44 || type === 53 || type === 82 ?
                        <div className='button' onClick={() => this.onOpenPopup(type)}>Настроить</div>
                        :
                        <div className="editor">
                            <div className="minus" onClick={this.onMinusClickHandler}>-</div>
                            <div className="count">{this.state.count === 0 ? '--' : this.state.count}</div>
                            <div className="plus" onClick={this.onPlusClickHandler}>+</div>
                            {count > 0 && <div className='basket' onClick={this.onAddProduct}>
                                <img src={cart} />
                            </div>
                            }
                        </div>}
                    {this.state.isFloorsNumberPopUpOpen && <FloorsNumbersPopUp onClose={() => { this.onOpenPopup(39) }} item={this.props.item} />}

                    {this.state.isPostsNumberPopUpOpen && 
                        (type === 51 || type === 81 || type === 48) && 
                        <PostsNumbersPopUp onClose={() => { this.onOpenPopup(type) }} item={this.props.item} />}

                    {this.state.isFlatsNumberPopUpOpen &&
                     (type === 43 || type === 46 || type === 79 || type === 47) &&
                      <FlatsNumbersPopUp onClose={() => { this.onOpenPopup(type) }} item={this.props.item} />}

                    {this.state.isFlatsNumbByfloorsPopUp && 
                        (type === 44 || type === 53 || type === 82) &&
                         <FlatsNumbByfloorsPopUp onClose={() => { this.onOpenPopup(type) }} item={this.props.item} />}


                    {this.state.isFlatsNumbWitArrPopUpOpen && <FlatsNumbWitArrPopUp onClose={() => { this.onOpenPopup(45) }} item={this.props.item} />}
                </div>
                <div className="title">{name}</div>
                <div className="data">
                    <div className='size'>{size}</div>
                    <div className='price'>{count === 0 ? Math.round(price) : price * count * (Number(leftIcon) + Number(rigthIcon))} руб</div>
                </div>
            </div>
        )
    }
}

export default Item